import { graphql } from "../generated/gql";

export const GetPlaybookResults = graphql(
  `
    query GetPlaybookResults($input: GetPlaybookResultsInput!) {
      getPlaybookResults(input: $input) {
        ... on GetPlaybookResultsResult {
          items {
            ...PlaybookResult
          }
        }
        ... on GenericException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
      }
    }
  `
);
